import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.parse-int";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.pad-start";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _toConsumableArray from "/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { areaList, areaAdd, agentList, agentHandle, agentDelete } from '@/api/apis';
export default {
  name: 'regionShow',
  data: function data() {
    return {
      loading: false,
      areaTree: [],
      agentMap: {},
      filterStatus: '',
      filterKeyword: '',
      editDialog: {
        visible: false,
        occupied: false,
        districtId: '',
        districtCode: '',
        provinceName: '',
        cityName: '',
        districtName: '',
        number: '',
        submitLoading: false,
        delLoading: false
      },
      editRules: {
        number: [{
          required: true,
          message: '请输入会员编号',
          trigger: 'blur'
        }]
      },
      // 添加区域弹窗
      addDialog: {
        visible: false,
        parent: [],
        name: '',
        code: '',
        loading: false
      },
      addRules: {
        name: [{
          required: true,
          message: '请输入区域名称',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入区域编码',
          trigger: 'blur'
        }, {
          pattern: /^\d+$/,
          message: '区域编码必须为数字',
          trigger: 'blur'
        }]
      },
      addCascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true
      }
    };
  },
  computed: {
    provinces: function provinces() {
      var _this = this;

      return this.areaTree.map(function (province) {
        var cities = (province.children || []).map(function (city) {
          var districts = (city.children || []).map(function (district) {
            var agent = _this.agentMap[district.id];
            return {
              id: district.id,
              name: district.name,
              code: district.code || district.id,
              provinceId: province.id,
              provinceName: province.name,
              cityId: city.id,
              cityName: city.name,
              occupied: !!agent,
              agentNumber: agent ? agent.number : ''
            };
          });
          return {
            id: city.id,
            name: city.name,
            districts: districts
          };
        });
        return {
          id: province.id,
          name: province.name,
          cities: cities
        };
      });
    },
    filteredProvinces: function filteredProvinces() {
      var _this2 = this;

      var kw = this.filterKeyword ? this.filterKeyword.toLowerCase() : '';
      return this.provinces.map(function (province) {
        var cities = province.cities.map(function (city) {
          var districts = city.districts.filter(function (d) {
            if (_this2.filterStatus === 'occupied' && !d.occupied) return false;
            if (_this2.filterStatus === 'free' && d.occupied) return false;

            if (kw) {
              var matchDistrict = d.name.toLowerCase().includes(kw);
              var matchAgent = d.agentNumber && d.agentNumber.toLowerCase().includes(kw);
              if (!matchDistrict && !matchAgent) return false;
            }

            return true;
          });
          return _objectSpread({}, city, {
            districts: districts
          });
        }).filter(function (c) {
          return c.districts.length > 0;
        });
        return _objectSpread({}, province, {
          cities: cities
        });
      }).filter(function (p) {
        return p.cities.length > 0;
      });
    },
    totalCount: function totalCount() {
      var count = 0;
      this.provinces.forEach(function (p) {
        return p.cities.forEach(function (c) {
          count += c.districts.length;
        });
      });
      return count;
    },
    occupiedCount: function occupiedCount() {
      var count = 0;
      this.provinces.forEach(function (p) {
        return p.cities.forEach(function (c) {
          return c.districts.forEach(function (d) {
            if (d.occupied) count++;
          });
        });
      });
      return count;
    },
    freeCount: function freeCount() {
      return this.totalCount - this.occupiedCount;
    },
    occupyRate: function occupyRate() {
      if (this.totalCount === 0) return 0;
      return (this.occupiedCount / this.totalCount * 100).toFixed(1);
    },
    addLevelTip: function addLevelTip() {
      var len = this.addDialog.parent ? this.addDialog.parent.length : 0;
      if (len === 0) return '当前将添加：省份（顶级区域）';
      if (len === 1) return '当前将添加：城市';
      if (len === 2) return '当前将添加：区/县';
      return '最多支持添加到区/县级';
    }
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    loadData: function loadData() {
      var _this3 = this;

      this.loading = true;
      Promise.all([areaList({}), agentList({})]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            areaRes = _ref2[0],
            agentRes = _ref2[1];

        _this3.areaTree = areaRes || [];
        var agentData = agentRes && agentRes.data ? agentRes.data : agentRes;
        var rows = agentData && agentData.rows || [];
        var map = {};
        rows.forEach(function (row) {
          if (row.district) {
            map[row.district] = row;
          }
        });
        _this3.agentMap = map;
        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    onFilterChange: function onFilterChange() {},
    onDistrictClick: function onDistrictClick(district) {
      var _this4 = this;

      this.editDialog = {
        visible: true,
        occupied: district.occupied,
        districtId: district.id,
        districtCode: district.code,
        provinceName: district.provinceName,
        cityName: district.cityName,
        districtName: district.name,
        number: district.agentNumber || '',
        submitLoading: false,
        delLoading: false
      };
      this.$nextTick(function () {
        if (_this4.$refs.editForm) {
          _this4.$refs.editForm.clearValidate();
        }
      });
    },
    onSubmitAgent: function onSubmitAgent() {
      var _this5 = this;

      this.$refs.editForm.validate(function (valid) {
        if (!valid) return;
        _this5.editDialog.submitLoading = true;
        var data = {
          number: _this5.editDialog.number,
          province: _this5.editDialog.provinceName,
          city: _this5.editDialog.cityName,
          district: _this5.editDialog.districtId
        };
        agentHandle(data).then(function (res) {
          _this5.$message({
            message: _this5.editDialog.occupied ? '修改成功' : '添加成功',
            type: 'success'
          });

          _this5.editDialog.visible = false;
          _this5.editDialog.submitLoading = false;

          _this5.loadData();
        }).catch(function () {
          _this5.editDialog.submitLoading = false;
        });
      });
    },
    onRemoveAgent: function onRemoveAgent() {
      var _this6 = this;

      this.$confirm("\u786E\u8BA4\u79FB\u9664\u300C".concat(this.editDialog.districtName, "\u300D\u7684\u4EE3\u7406\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this6.editDialog.delLoading = true;
        agentDelete({
          number: _this6.editDialog.number
        }).then(function (res) {
          _this6.$message({
            message: '移除成功',
            type: 'success'
          });

          _this6.editDialog.visible = false;
          _this6.editDialog.delLoading = false;

          _this6.loadData();
        }).catch(function () {
          _this6.editDialog.delLoading = false;
        });
      }).catch(function () {});
    },
    // ===== 添加区域 =====
    // 按 id 在区域树中查找节点
    findNode: function findNode(id) {
      var found = null;

      var walk = function walk(nodes) {
        for (var i in nodes) {
          if (nodes[i].id === id) {
            found = nodes[i];
            return;
          }

          if (nodes[i].children) walk(nodes[i].children);
        }
      };

      walk(this.areaTree);
      return found;
    },
    // 自动生成区域编码：同级最大编码 +1，无同级时按上级编码续编
    genCode: function genCode(parentNode, siblings) {
      var codes = (siblings || []).map(function (s) {
        return String(s.id);
      });
      var nums = codes.map(function (c) {
        return /^\d+$/.test(c) ? parseInt(c, 10) : NaN;
      }).filter(function (n) {
        return !isNaN(n);
      });

      if (nums.length) {
        var maxNum = Math.max.apply(Math, _toConsumableArray(nums));
        var maxCode = codes.find(function (c) {
          return parseInt(c, 10) === maxNum;
        });
        return String(maxNum + 1).padStart(maxCode.length, '0');
      }

      if (parentNode) {
        var pCode = String(parentNode.id);
        return /^\d+$/.test(pCode) ? pCode + '01' : pCode + '-01';
      }

      return '01';
    },
    // 上级区域变化时自动生成编码
    onAddParentChange: function onAddParentChange(val) {
      if (val && val.length >= 3) {
        this.$message({
          message: '最多支持添加到区/县级',
          type: 'warning'
        });
        this.addDialog.code = '';
        return;
      }

      var parent = null;
      var siblings = this.areaTree;

      if (val && val.length) {
        parent = this.findNode(val[val.length - 1]);
        siblings = parent && parent.children || [];
      }

      this.addDialog.code = this.genCode(parent, siblings);
    },
    showAddDialog: function showAddDialog() {
      var _this7 = this;

      this.addDialog = {
        visible: true,
        parent: [],
        name: '',
        code: this.genCode(null, this.areaTree),
        loading: false
      };
      this.$nextTick(function () {
        if (_this7.$refs.addForm) {
          _this7.$refs.addForm.clearValidate();
        }
      });
    },
    onSubmitAdd: function onSubmitAdd() {
      var _this8 = this;

      this.$refs.addForm.validate(function (valid) {
        if (!valid) return;
        var parent = _this8.addDialog.parent || [];

        if (parent.length >= 3) {
          _this8.$message({
            message: '最多支持添加到区/县级',
            type: 'warning'
          });

          return;
        }

        _this8.addDialog.loading = true;
        areaAdd({
          id: parseInt(_this8.addDialog.code, 10),
          parent_id: parent.length ? parseInt(parent[parent.length - 1], 10) : 0,
          depth: parent.length + 1,
          name: _this8.addDialog.name
        }).then(function (res) {
          _this8.$message({
            message: '添加成功',
            type: 'success'
          });

          _this8.addDialog.visible = false;
          _this8.addDialog.loading = false;

          _this8.loadData();
        }).catch(function () {
          _this8.addDialog.loading = false;
        });
      });
    }
  }
};